import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    data: {}
};

const staticDataSlice = createSlice({
    name: 'staticData',
    initialState,
    reducers: {
        setStaticData: (state,action) => {
            state.data = {...state.data, ...action.payload}
        }
    }
});

export const { setStaticData } = staticDataSlice.actions;
export const staticDataSelector = (state) => state.staticData;
export const staticDataReducer = staticDataSlice.reducer;